/** Nutrient AI demo (book AI consent toggle). Set REACT_APP_NUTRIENT_ACTIVE=true in .env */
export const isNutrientActive =
  process.env.REACT_APP_NUTRIENT_ACTIVE === "true";
